import { Icon } from './ui'
import { useMyWorkTotal } from './MyWorkCount'
import { MY_WORK_ALL } from '../lib/myWork'
import '../styles/sweep.css'

// The bell: a link to My work's whole list, with its count, the same number
// as the sidebar badge and Home's "Waiting for you".
//
// # WHY IT IS NO LONGER A LIST
//
// The bell opened its own panel of notices, "Work waiting for you inside the
// product", while Home had "Needs you": two partial inboxes with different
// contents, different words and no shared done state, and neither held vendor
// approvals, tier changes or replies to decide (release 3.2, duplication map
// 1.5). My work is now the one list. It carries the notices the bell carried,
// less the ones that only repeated a task already on it, under a Notices filter
// of their own, and marks them read there; the bell keeps its place in the
// header and opens the list.

export function NoticeBell() {
  const n = useMyWorkTotal()
  const said = n === 0 ? 'My work, nothing waiting' : 'My work, ' + n + ' waiting for you'
  return (
    <div className="notice-bell">
      <a className="notice-trigger" href={MY_WORK_ALL} title={said} aria-label={said}>
        <Icon name="bell" size={17} />
        {n > 0 && <span className="notice-count">{n}</span>}
      </a>
    </div>
  )
}
